import React, { useState, useEffect } from 'react';
import { Alert, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const PaymentsConvertingAlert = ({ theme }) => {
  const [isAlertOpen, setAlertOpenState] = useState(false);
  const hideAlert = () => {
    localStorage.setItem('WMZ_alert_hidden', true);
    setAlertOpenState(false);
  };

  useEffect(() => {
    const isAlertHidden = localStorage.getItem('WMZ_alert_hidden');

    !isAlertHidden && setAlertOpenState(true);
  }, []);

  return (
    <Alert color="success" className={theme ? `payment-conversion-alert-theme-${theme}` : ''} isOpen={isAlertOpen} toggle={hideAlert}>
      <Row>
        <Col xs="12" md="4" xl="4" className="wmz-alert-primary">
          <FormattedMessage
            id="payments.wmz-alert.primary"
            defaultMessage="Withdraw rubles and dollars on one single WMZ purse!"
          />
        </Col>
        <Col xs="12" md="8" xl="7" className="wmz-alert-secondary">
          <FormattedMessage
            id="payments.wmz-alert.secondary"
            defaultMessage="Starting from 27.08.19 it' s available to order payments in rubles on WebMoney's WMZ purse with the most profitable terms. Currency convertion uses Russian Federaion Central Bank order's date rate!"
          />
        </Col>
      </Row>
    </Alert>
  );
};

export default PaymentsConvertingAlert;
